import { useRef, useCallback } from 'react';

import { useNativeCollabConnected, useNativeCollabState } from '@confluence/native-collab';

/**
 * This hook serves to pull handlers and wait for them to be ready, so that
 * we can pass callbacks immediately to the `editor plugin ai`
 */
export const useEditorPluginAICollabConnector = () => {
	const [{ collabEditConnected }] = useNativeCollabConnected();
	const [{ collabEditProvider }] = useNativeCollabState();

	const aiProviders = useRef<Record<string, any>>({});

	const onAIProviderChanged = useCallback(
		(source, provider) => {
			if (!collabEditConnected || !collabEditProvider) {
				return;
			}

			let agentId = provider?.agent?.id;
			const agentIdPrefix = 'agent:';
			const action = agentId ? 'add' : 'remove';

			// Fetch the previously enabled provider's ID as it isn't provided
			// when unsetting the selected provider
			if (aiProviders.current[source]) {
				agentId = aiProviders.current[source];
			}

			aiProviders.current[source] = provider?.agent?.id;

			if (agentId) {
				const providerId = `${agentIdPrefix}${agentId}`;

				collabEditProvider.sendMessage({
					type: 'ai-provider:change',
					action,
					providerId,
				});
			}

			collabEditProvider.setAIProviderActiveIds(
				Object.values(aiProviders.current)
					.filter((id) => !!id)
					.map((id) => `${agentIdPrefix}${id}`),
			);
		},
		[collabEditConnected, collabEditProvider],
	);

	return {
		onAIProviderChanged,
	};
};
